import React from 'react';
import DOMPurify from 'dompurify';

// Components
import { Text } from '@react-pdf/renderer';
import Paragraph from '../../Paragraph';

export default function Contributor({
  contributor
}) {
  return (
    <Paragraph title="Contributor">
      <Text>{DOMPurify.sanitize(contributor || '')}</Text>
    </Paragraph>
  );
}